import { useDispatch as useDispatchGeneric } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { GlobalState } from "@/Reducers/interface";
import { Action } from "redux";

const useDispatch: () => ThunkDispatch<GlobalState, any, Action> =
	useDispatchGeneric;

export default useDispatch;
